import { j as f } from "./jsx-runtime-3tyXYecC.mjs";
import { isValidElement as I, Children as j } from "react";
import { c as L } from "./index-DkZ16bcJ.mjs";
import { m as v } from "./tss-DN0acMKN.mjs";
import { M as C, d as O } from "./constants-CnFYFetN.mjs";
import { l as u } from "./lodash-5ofSKtz3.mjs";
import { m as S } from "./motion-B7Equlyg.mjs";
const b = v()(({ spacing: n, mode: r }) => ({
  root: {
    display: "grid",
    gap: 10,
    outline: r === C.Dye ? `${n(0.5)} solid ${O.main}` : void 0
  }
})), w = v()(() => ({
  root: {
    display: "grid"
  }
}));
function E(n, r) {
  return !I(n) && u.isFunction(n) ? n({ ...r }) : n;
}
function _(n) {
  const { animate: r = !0, className: e, layoutKey: t, children: i, transition: s = {}, ...p } = n, { classes: o } = w(), c = E(i, p), d = {
    className: L(o.root, e),
    style: {
      gridArea: t
    }
  };
  return r ? /* @__PURE__ */ f.jsx(
    S.div,
    {
      "aria-live": "polite",
      layout: !0,
      transition: {
        type: "easeInOut",
        ...s
      },
      ...d,
      children: c
    }
  ) : /* @__PURE__ */ f.jsx("div", { ...d, children: c });
}
function T(n) {
  return /* @__PURE__ */ f.jsx(f.Fragment, {});
}
function k(n) {
  return `"${n.map((e, t) => e.map((i, s) => i === void 0 ? `lattice-internal-null-${t}-${s}` : i).join(" ")).join('""')}"`;
}
function A(n) {
  return new Set(u.flatten(n));
}
function F(n, r) {
  const e = n.findIndex((o) => o.includes(r)), t = n.filter((o) => o.includes(r)).length, i = n[e] || [], s = i.indexOf(r), p = i.filter((o) => o === r).length;
  return {
    row: e,
    rowSpan: t,
    column: s,
    columnSpan: p
  };
}
function g(n) {
  return n.map((r) => [...r]);
}
function M(n) {
  const r = Array.from({ length: n[0].length }, () => []);
  return n.forEach((e) => {
    e.forEach((t, i) => {
      r[i].push(t);
    });
  }), r.reverse();
}
function P(n) {
  const r = Array.from({ length: n[0].length }, () => []);
  return n.forEach((e) => {
    e.forEach((t, i) => {
      r[i].unshift(t);
    });
  }), r;
}
function $(n, r) {
  const e = [...n];
  return e.push(e.splice(r, 1)[0]), e;
}
function h(n) {
  const r = Math.max(...n.map((e) => e.length));
  return n = n.map((e, t) => (e.length < r && (e.length = r), [...e])), n = n.map((e) => e.map((t) => t === void 0 ? "." : t)), n;
}
function a(n) {
  return n === "." ? n : u.kebabCase(n);
}
function l(n) {
  return n.map(
    (r) => r.map((e) => typeof e == "string" ? a(e) : ".")
  );
}
function B(n, r) {
  n = g(n), n = h(n), n = l(n), r = a(r);
  let e = -1, t = n.findIndex((i) => (e = i.findIndex((s) => s === r), e > -1));
  return n[t][e] = ".", n.splice(t, 0, [r, r], [r, r]), t += 2, n = M(n).reverse(), [t, e] = [e, t], n[t] = $(n[t], e), P(n.reverse());
}
function N(n, r) {
  n = g(n), n = h(n), n = l(n), r = a(r);
  let e = -1;
  const t = n.findIndex((i) => (e = i.findIndex((s) => s === r), e > -1));
  return (e === 0 || e === 2) && (e === 2 && (n = n.map((i) => i.reverse())), n.splice(t + 1, 0, [...n[t]]), n[t][2] = n[t][1], n[t][1] = r, n[t + 1][1] = r, e === 2 && (n = n.map((i) => i.reverse()))), e === 1 && (n.splice(t + 1, 0, [...n[t]]), n[t + 1][0] = n[t][2], n[t][2] = r, n[t + 1][2] = r), n;
}
const R = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  threeColumnOneByOneToTwoByTwo: N,
  twoColumnOneByOneToTwoByTwo: B
}, Symbol.toStringTag, { value: "Module" }));
function z(n, r) {
  if (n.length === 0)
    return [];
  n = [...n];
  const e = u.chunk(n, r);
  return e[0].length < r && (e[0].length = r), h(e);
}
const U = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  toLayout: z
}, Symbol.toStringTag, { value: "Module" }));
function x({ animate: n = !0, children: r, layout: e, className: t }) {
  const { classes: i } = b();
  if (e.length === 0)
    return /* @__PURE__ */ f.jsx(f.Fragment, {});
  e = g(e), e = h(e), e = l(e);
  const s = A(e), p = e[0].length, o = j.map(r, (c) => {
    if (!I(c) || c.type !== T)
      return null;
    const { children: d } = c.props;
    let { layoutKey: m } = c.props;
    return m = a(m), s.has(m) ? (
      // Add child.props to pass-through any additional props... like className
      /* @__PURE__ */ f.jsx(_, { ...c.props, ...F(e, m), animate: n, layoutKey: m, children: d })
    ) : null;
  });
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: L(i.root, t),
      "data-fabric-component": "Lattice",
      style: {
        gridTemplateAreas: k(e),
        gridTemplateColumns: "1fr ".repeat(p).trim()
      },
      children: o
    }
  );
}
x.Item = T;
x.LayoutCalculators = R;
x.Utils = U;
export {
  x as L
};
//# sourceMappingURL=lattice-BWAFF--c.mjs.map
